import api from "../index";


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    make_order: (payload) => api.post(`/orders`, payload),
}